/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".previous-levels-container[_ngcontent-%COMP%]{margin-bottom:25px;min-height:0;opacity:1;padding-bottom:4rem}.child-header-container[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{color:#0080ff;font-size:1.5rem;margin:10px 0}"];
export { styles as styles };
//# sourceMappingURL=previous-levels-page.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/industry-content/previous-levels-page/previous-levels-page.component.scss.shim.ngstyle.js
// module id = 1628
// module chunks = 26 27 28